import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

window.__reactRouterContext = {
  isSpaMode: false
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);